export const STATUS_META = {
  draft: { label: 'Brouillon', cls: 'bg-gray-100 text-gray-700 border-gray-200' },
  received: { label: 'Reçu', cls: 'bg-blue-50 text-blue-700 border-blue-200' },
  to_verify: { label: 'À vérifier', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  incomplete: { label: 'Incomplet', cls: 'bg-orange-50 text-orange-700 border-orange-200' },
  validated: { label: 'Validé', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  sent_to_fabricant: { label: 'Envoyé au laboratoire', cls: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
  in_production: { label: 'En production', cls: 'bg-violet-50 text-violet-700 border-violet-200' },
  fabricant_question: { label: 'Question laboratoire', cls: 'bg-rose-50 text-rose-700 border-rose-200' },
  return_received: { label: 'Retour reçu', cls: 'bg-cyan-50 text-cyan-700 border-cyan-200' },
  quality_control: { label: 'Contrôle qualité', cls: 'bg-teal-50 text-teal-700 border-teal-200' },
  shipped_to_cabinet: { label: 'Expédié au cabinet', cls: 'bg-sky-50 text-sky-700 border-sky-200' },
  completed: { label: 'Terminé', cls: 'bg-green-50 text-green-700 border-green-200' },
  cancelled: { label: 'Annulé', cls: 'bg-zinc-100 text-zinc-600 border-zinc-200' },
  dispute: { label: 'Litige', cls: 'bg-red-50 text-red-700 border-red-200' },
};

export const statusMeta = (s) => STATUS_META[s] || { label: s, cls: 'bg-gray-100 text-gray-700 border-gray-200' };

export const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

export const fmtDateTime = (iso) => iso ? new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—';

export const fmtSize = (bytes) => {
  if (!bytes) return '0 o';
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
};
